import { handleDialogEntered } from "utils/Utilites";

const dialogConfig = {
    components: {
        MuiDialog: {
            TransitionProps: {
                onEntered: handleDialogEntered,
            },
        }
    }
}

/**
 * Светлая тема приложения
 */
const lightTheme = {
    palette: {
        mode: 'light',
        primary: {
            main: '#009881', //#388e3c',
        },
        secondary: {
            main: '#9c27b0',
        },
        background: {
            default: '#e4f0e2',
            paper: '#EFF7FF', // card
        },
    },
    ...dialogConfig,
};

/**
 * Темная тема приложения
 */
const darkTheme = {
    palette: {
        mode: 'dark',
        primary: {
            main: '#00c9a7', 
        },
        secondary: {
            main: '#ba68c8',
        },
        background: {
        default: '#121f17',
        paper: '#1e2b22', 
        },
        text: {
            primary: '#e0e0e0',
            secondary: '#a0a0a0',
        },
    },
    ...dialogConfig,
};

/**
 * Конфигурация цветовых тем приложения (светлая и тёмная).
 * Используется для инициализации `createTheme()` из `@mui/material/styles`.
 * Темы соответствуют дизайн-системе приложения и включают основные палитры:
 * - primary (основной акцент — зелёный оттенок);
 * - secondary (дополнительный акцент — фиолетовый);
 * - background (фон страницы и карточек);
 * - text (в тёмной теме — явно заданы цвета текста для контрастности).
 *
 * @type {Object}
 * @property {Object} light - Светлая тема.
 * @property {Object} dark - Тёмная тема.
 */
export const themeConfig = {
    light: lightTheme,
    dark: darkTheme,
};